import { defineStore } from 'pinia'
import { retrieveCountryList } from '@/api/common'

export const useCountryStore = defineStore('bestdealer-country', () => {
  const list = shallowRef([])
  const timestamp = ref(+new Date())
  const ipCountry = shallowRef({
    phoneCode: '+1',
    countryCode: 'US',
    countryName: 'United States',
    countryUrl: 'https://cdn-image-old.bestdealer.com/us.svg',
    language: 'en'
  })

  const init = async () => {
    if (list.value.length > 0 && Date.now() - timestamp.value < 24 * 60 * 60 * 1000) return
    const { code, data } = await retrieveCountryList()
    if (code === 200) {
      list.value = data
      ipCountry.value = data[0]
    }
  }

  return {
    timestamp,
    list,
    ipCountry,
    init
  }
}, {
  persist: true
})
